<template>
    <div class="dlistnum_con column">
                    <div class="fifth">
                      <div class="issue_year">Year/Issue</div>
                        <div ref="len2">
                          <div v-loading="loading" style="margin-top: 20px;">
                          <div class="Issueline" v-for='(item,b) in Year' v-if="b<num" :key="b">
                          <div class="highblue leftfloat year_issue">
                            <div>{{item.PublishYear}}</div>
                            <div>(Vol. {{item.Volume}})</div>
                          </div>
                          <div class="leftfloat ml15 volum_issue" style="margin-left:20px">
                            <ul>
                              <li class="issue_directory" v-for='(uitem,c) in item.Issue' :key="c">
                                <a @click="tomouthgzh(uitem.IssueId)" v-if="isgzh">
                                    <p>Isse {{parseInt(uitem.IssueNumE)}}</p>
                                </a>

                                <a @click="tomouth(uitem.IssueId)" v-else>
                                    <p>Issue {{parseInt(uitem.IssueNumE)}}</p>
                                </a>
                                
                                <p title="Publish Date">{{uitem.Publish_Date}}</p>
                              </li>
                            </ul>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        </div>
                      <a href="javascript:;"  @click="opena2" ref="openp2" v-if="Year.length>3" style=" cursor: pointer;">Unfold</a>
                    </div>
                    </div>
                    <div class="fifth" v-if="Column != null && Column.length>0">
                      <div class="issue_year" ref="menu">Column</div>
                      <div v-loading="loading" style="margin-top: 20px;">
                      <ul class="Column_list" ref="len1" style="height:80px;overflow:hidden;">
                        <li v-for='(item,a) in Column' :key="a" ref="lenli1" @click="tomoutha(item.ItemID,'Column')">
                        <a :title="item.ItemNameE">{{item.ItemNameE}}</a>
                        (<span class='red'>{{item.Count}}</span>)
                        </li>
                      </ul>
                      <div class="clearfix"></div>
                      <a href="javascript:;" @click="opena1" ref="openp1" style=" cursor: pointer;" v-if="Column.length>12">Unfold</a>
                    </div>
                    </div>
                    <div class="fifth" v-if="Field != null && Field.length>0">
                      <div class="issue_year" ref="menu">field Column</div>
                      <div v-loading="loading" style="margin-top: 20px;">
                      <ul class="Column_list" ref="len" style="height:80px;overflow:hidden">
                        <li v-for='(item,i) in Field' :key="i" ref="lenli" @click="tomoutha(item.ItemID,'Field')">
                          <a :title="item.ItemNameE">{{item.ItemNameE}}</a>
                          (<span class='red'>{{item.Count}}</span>)
                        </li>
                      </ul>
                      <div class="clearfix"></div>
                      <a href="javascript:;" @click="opena" ref="openp" style=" cursor: pointer;" v-if="Field.length>12">Unfold</a>
                    </div>
                    </div>
                  </div>
</template>
<script>
export default {
    data(){
        return{
            Year: [],
            Column: [],
            title: '',
            Field: [],
            islingyu:false,
            islanmu:false,
            num:3,
            loading:true,
        }
    },
    props:['isgzh'],
    mounted(){
      if(sessionStorage.getItem("SetItem")){
        let SetItem=JSON.parse(sessionStorage.getItem("SetItem"))
        SetItem.map((item)=>{
              if(item.SetItemID==1001){
                this.title=item.Item_Value
              }
              if(item.SetItemID==99){
                if(item.Item_Value=="是"){
                  this.islingyu=true
                }else{
                  this.islingyu=false
                }
              }
              if(item.SetItemID==96){
                if(item.Item_Value=="是"){
                  this.islanmu=true
                }else{
                  this.islanmu=false
                }
              }
          })
       this.getmenu()
      }else{
         let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,2960]
          //1000:期刊名称
          //1001：期刊英文名称
          //4530：（否）隐藏/（是）显示预出版模块
          //6018:预出版模块显示 （否）基于OA预出版/（是）基于稿件预出版
          //6019：是否需要登录下载文件
          //230：显示/隐藏所有的评论功能
          //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
          //5000： ISSN编号
          //5010：CN编号
          this.$store.dispatch("_getSet",params).then(res=>{
              sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
            let  SetItem=res.data.Data
            SetItem.map((item)=>{
              if(item.SetItemID==1001){
                this.title=item.Item_Value
              }
              if(item.SetItemID==99){
                if(item.Item_Value=="是"){
                  this.islingyu=true
                }else{
                  this.islingyu=false
                }
              }
              if(item.SetItemID==96){
                if(item.Item_Value=="是"){
                  this.islanmu=true
                }else{
                  this.islanmu=false
                }
              }
          })
          
       this.getmenu()
          })
      }
          
    },
    methods:{
        getmenu(){
        this.$store.dispatch("_getgok").then(res=>{
          if(res.data.IsSuccess){
            this.loading=false
            this.Year = res.data.Data.Year
          
          if(this.islingyu==true){
            this.Field = res.data.Data.Field
          }else{
            this.Field =[]
          }
          if(this.islanmu==true){
            this.Column = res.data.Data.Column
            
          }else{
            this.Column=[]
          }
          }else{

          }
            
        }).catch(err=>{
            console.log(err)
        })
        },
        
      tomouth(id,type) {
        this.$router.push({
          path: '/OAList?IssueId=' + id
        })
      
      },
      tomouthgzh(id,type) {
        this.$router.push({
          path: '/gzhOAList?IssueId=' + id
        })
      
      },
       tomoutha(id,type) {
        this.$router.push({
          path: '/FieldColumnList?IssueId=' + id+"&type="+type
        })
      
      },
      opena() {
        if (this.$refs.openp.innerText === 'Unfold') {
          this.$refs.len.style.height = ''
          this.$refs.openp.innerText = 'shrink'
        } else {
          this.$refs.len.style.height = 80 + 'px'
          this.$refs.openp.innerText = 'Unfold'
        }
      },
      opena1() {
        if (this.$refs.openp1.innerText === 'Unfold') {
          this.$refs.len1.style.height = ''
          this.$refs.openp1.innerText = 'shrink'
        } else {
          this.$refs.len1.style.height = 80 + 'px'
          this.$refs.openp1.innerText = 'Unfold'
        }
      },
      opena2() {
        if (this.$refs.openp2.innerText === 'Unfold') {
          // this.$refs.len2.style.height = ''
          this.num=this.Year.length
          this.$refs.openp2.innerText = 'shrink'
        } else {
          // this.$refs.len2.style.height = 380 + 'px'
          this.num=3
          this.$refs.openp2.innerText = 'Unfold'
        }
      }
    }
}
</script>
<style scoped>
  ul li a{
      cursor: pointer;

  }
.Column_list li  a{
    display: inline-block;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    float: left;
  }
</style>